import React, { useEffect, useState } from 'react'
import CartItems from "./CartItems";
import SpecialInstructions from './SpecialInstructions';
import SuggestiveItems from './SuggestiveItems';
import BucketCartItems from './BucketCartItems';
import GusetCheckOut from './gusetcheckout';
import { connect, useSelector } from 'react-redux';
import { getCart, getCrossSellItems, handleAlternateNumber, handleSpecialInstruction, saveCart } from '../../Redux';
import kfcbasket from "../../Assetes/Images/kfc-basket2.svg"
import KfcMeal from "../../Assetes/Images/kfc-meal.png"
import mergn from 'mergn-webapp-sdk'
import { Link, useHistory } from 'react-router-dom';
import Header from '../../Components/Header';
import useTrackEvent from '../../hooks/useTrackHook';
import { toast } from 'react-toastify';
import { API_URL, IMAGE_URL } from '../../Components/client-config';
import axios from 'axios';
import _ from 'lodash';
import { Modal } from 'react-bootstrap';
import Button from '@mui/material/Button';
import jwt_decode from 'jwt-decode';
import GoBack from '../BackButton/GoBack';
import Donation from './Donation/Donation';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { checkPhone } from '../../lib';
import CouponCode from './CouponCode';
var CryptoJS = require("crypto-js");

function Bucket(props: any) {
  const cartData = useSelector((state: any) => state.cart.cartData);
  const orderType = useSelector((state: any) => state.payment.orderType);
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const guestInfo = useSelector((state: any) => state.customer.guestInfo)
  const cartQty = useSelector((state: any) => state.cart.cartQty);
  const paymentMethod = useSelector((state: any) => state.payment.paymentMethod);
  const payment_tax = useSelector((state: any) => state.payment.payment_tax);
  const taxDataCash = useSelector((state: any) => state.store.taxDataCash);
  const taxDataCard = useSelector((state: any) => state.store.taxDataCard);
  const inst = useSelector((state: any) => state.cart.special_instructions);
  const posFee = useSelector((state: any) => state.store.pos_fee);
  const [value, setValue] = useState(0);
  const [addEvent] = useTrackEvent();
  const [specificStoreItemsData, setSpecificStoreItemsData] = useState([]);
  let [removeableLsmItemsArr, setRemoveablLSMItems]: any = useState([]);
  let [showHide, setShowHide]: any = useState(false);
  let [clickNext, setClickNext]: any = useState(false)
  const [headerUpdate, setHeaderUpdate] = useState(0);
  const history = useHistory();
  const lang = useCurrentLocale();


  useEffect(() => {
    window.scrollTo(0, 0);
    let body: any = {
      mode: "online",
      channel: orderType ? orderType : null,
      store_id: storeSelected ? storeSelected.store_id : null
    }
    props.getCrossSellItems(body)
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });

    const viewCartData: any = {
      currency: "PKR",
      items: [],
      value: 0
    }

    cartData.forEach((item: any) => {
      if (item.item) {
        viewCartData.items.push({
          item_id: item.item.menu_item_id,
          item_name: item.item.item_name,
          price: item.price,
          quantity: item.quantity,
          item_category: item.item.item_group_id.group_name,
          discount: item.item?.item_size && item.item.item_size[0]?.discount_value ? item.item.item_size[0].discount_value : 0
        })
        viewCartData.value += item.price * item.quantity
      }
      else {
        viewCartData.items.push({
          item_id: item.combo.combo_id,
          item_name: item.combo.combo_name,
          price: item.price,
          quantity: item.quantity,
          item_category: item.combo.group_id.group_name,
          discount: item.combo?.discount_value ? item.combo.discount_value : 0
        })
        viewCartData.value += item.price * item.quantity
      }
    })

    windowObj.dataLayer.push({
      'event': 'view_cart',
      'ecommerce': {
        ...viewCartData
      }
    });
  }, []);

    const calculateTax = (total_price: any) => {
      if (paymentMethod && paymentMethod !== 'Cash' && payment_tax) {
          const delivery_fee_tax_amount = (props.deliveryfee) * parseInt(taxDataCard.tax_percent) / (100 + parseInt(taxDataCard.tax_percent));
          let inclusive_tax: any = (total_price) * parseInt(taxDataCard.tax_percent) / (100 + parseInt(taxDataCard.tax_percent));
          return props.orderType == "Delivery" ? Math.round(inclusive_tax) + Math.round(delivery_fee_tax_amount) : Math.round(inclusive_tax)
      } else {
          let inclusive_tax: any = (total_price) * parseInt(taxDataCash.tax_percent) / (100 + parseInt(taxDataCash.tax_percent));
          return Math.round(inclusive_tax)
      }
  }
  const calcTotal = (data: any) => {
      let sum: any = 0;
      data.forEach((item: any) => {
          sum += (item.updateOnlineItemPrice && item.updateOnlineItemPrice > 0) ? item.updateOnlineItemPrice : parseInt(item.totalItemPrice);
      });
      if (orderType == "Delivery") {
          if (!_.isEmpty(props.storeSelected)) {
              sum = posFee > 0 ? sum + (props.onlineDeliveryfee > 0 ? props.onlineDeliveryfee : props.deliveryfee) + parseInt(posFee) : sum + (props.onlineDeliveryfee > 0 ? props.onlineDeliveryfee : props.deliveryfee);
          }
          else {
              sum = posFee > 0 ? sum + parseInt(posFee) : sum;
          }
      }
      else if (orderType == "Pickup") {
        sum = posFee > 0 ? sum + parseInt(posFee) : sum;
      }
      let finalSum = sum;
      return Math.round(finalSum);
  };
  const calcItemTotal = (carts: any) => {
      let sum = 0;
      carts.forEach((item: any) => {
          sum += (item.updateOnlineItemPrice && item.updateOnlineItemPrice > 0) ? item.updateOnlineItemPrice : parseInt(item.totalItemPrice);
      });
      return sum;
  };

  const handleCheckoutClick = () => {

    mergn.recordEvent('Checkout Click', [
      { eventProperty: 'instructions', value: inst ?? '' },
      { eventProperty: 'sub-total', value: calcItemTotal(cartData) },
      { eventProperty: 'gst', value: calculateTax(calcItemTotal(cartData)) },
      { eventProperty: 'total', value: calcTotal(cartData) },
      { eventProperty: 'total-items', value: cartQty }
    ]);

  }

  const validateStoreSpecification = async () => {
    setClickNext(true)
    handleCheckoutClick()
    let token = localStorage.getItem("userToken");
    if (token) {
      let decoded: any = jwt_decode(token)
      if (!checkPhone(decoded.customer.phone_number?.split("-")[1]) || _.isEmpty(decoded.customer.login_name) || decoded.customer.login_name == ' ') {
        toast.success(t("UPDATE_YOUR_PROFILE_INFORMATION"))
        setTimeout(() => { history.push(`/${lang}/my-details`); }, 500)
        return;
      }
    }
    if (cartData && cartData.length > 0) {
      const obj: any = {
        cart: cartData,
        mode: 'online',
        store_id: storeSelected ? Number(storeSelected.store_id) : null,
      };
      const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
      axios.post(`${API_URL}menu/getItemsForSpecificStore`, { body: encryptedData }).then((res: any) => {
        const specificStoreItems = res.data.data;
        setSpecificStoreItemsData(specificStoreItems);
        // Find items in cartData that are marked as is_valid: false in result
        const lsmItemRemove = cartData.filter((cartItem: any, index: number) => {
          return specificStoreItems.some((resultItem: any) => {
            if (cartItem.item) {
              return (
                !resultItem.is_valid && // Check if is_valid is false
                resultItem.cart_index === index && // Match the cart_index
                cartItem.item?.menu_item_id === resultItem.menu_item_id // Match menu_item_id
              );
            } else {
              return (
                !resultItem.is_valid && // Check if is_valid is false
                resultItem.cart_index === index && // Match the cart_index
                cartItem.combo?.combo_id === resultItem.combo_id // Match combo_id
              );
            }
          });
        });
        setRemoveablLSMItems(lsmItemRemove);
        if (lsmItemRemove.length > 0) {
          setShowHide(true)
        } else {
          setShowHide(null)
          setClickNext(false)
          let items: any = []
          let totalAmmount = 0
          let beginCheckout: any = {
            currency: 'PKR'
          }
          cartData.forEach((item: any) => {
            let obj = {
              item_id: item.combo ? item.combo.combo_id : item.item.menu_item_id,
              item_name: item.combo ? item.combo.combo_name : item.item.item_name,
              discount: item.item && item.item?.item_size[0] && item.item.item_size[0]?.discount_value ? item.item.item_size[0].discount_value : item.combo?.discount_value ? item.combo.discount_value : 0,
              quantity: item.quantity,
              price: item.totalItemPrice,
              index: item.combo ? item.combo.priority : item.item.priority,
              item_category: item.combo ? item.combo.group_id.group_name : item.item.item_group_id.group_name
            }
            totalAmmount += item.totalItemPrice
            items.push(obj)
          })
          beginCheckout['items'] = items;
          beginCheckout['value'] = totalAmmount
          if (token || guestInfo) {
            let windowObj = (window as any)
            windowObj.dataLayer.push({ ecommerce: null });
            windowObj.dataLayer.push({
              'event': 'begin_checkout',
              'ecommerce': {
                ...beginCheckout
              }
            });
            history.push(`/${lang}/payment-method`);
          } else {
            history.push(`/${lang}/details`);
          }
        }
      })
        .catch(err => {
          alert("something went wrong")
          setClickNext(false);
        })
    }
  }

  const removeLsmItems = () => {
    if (cartData && cartData.length > 0) {
      let dupCart: any = structuredClone(cartData);
      const filteredCart = dupCart.filter((cartItem: any, index: number) => {
        return !specificStoreItemsData.some((resultItem: any) => {
          if (cartItem.item) {
            return (
              !resultItem.is_valid && // Check if is_valid is false
              resultItem.cart_index === index && // Match the cart_index
              cartItem.item?.menu_item_id === resultItem.menu_item_id // Match menu_item_id
            );
          } else {
            return (
              !resultItem.is_valid && // Check if is_valid is false
              resultItem.cart_index === index && // Match the cart_index
              cartItem.combo?.combo_id === resultItem.combo_id // Match combo_id
            );
          }
        });
      });
      props.saveCart(filteredCart)
      setShowHide(false)
      setClickNext(false)
    }
  };
  const handleClose = () => {
    setShowHide(false)
    setClickNext(false)
    setRemoveablLSMItems([])
  }
  const { t } = useTranslation();

  return (
    <div className='bucket-container'>
      <Header headerUpdate={headerUpdate} setValue={setValue} value={value} />
      <div className="main-height">
        <div className="container-xxl category-container-custom mt-120 mb-md-100">
          <div className="row">
            <div className="col-lg-8">
              <div className='your-cart mb-5'>

                <div>
                  <h5 className='your-text d-flex align-items-center gap-10 '>
                    <GoBack />
                    <span>{t("ITEMS_FROM_YOUR_CART")}</span></h5>
                </div>
                <div className='your-items'>
                  {(cartData && cartData.length > 0) ?
                    (storeSelected ?
                      cartData.map((carts: any, index: any) => {
                        return <CartItems carts={carts} index={index} setValue={setValue} value={value} setHeaderUpdate={setHeaderUpdate} headerUpdate={headerUpdate} />
                      }) : <div className='kfc-basket' style={{ aspectRatio: 0 }}>
                        <img src={KfcMeal} alt="" />
                        <h5>{t("NO_ITEMS_IN_BUCKET")}</h5>
                        <Link to={`/${lang}/menu`}><button onClick={() => addEvent({ category: "events", events: "Explore Menu button" })} >{t("EXPLOREMENU")}</button></Link>
                      </div>) :
                    <div className='kfc-basket' style={{ aspectRatio: 0 }}>
                      <img src={KfcMeal} alt="" />
                      <h5>{t("NO_ITEMS_IN_BUCKET")}</h5>
                      <Link to={`/${lang}/menu`}><button onClick={() => addEvent({ category: "events", events: "Explore Menu button" })} >{t("EXPLOREMENU")}</button></Link>
                    </div>}
                </div>
              </div>
              {cartQty > 0 ? <Donation /> : null}
              <div className='my-5'>
                <SuggestiveItems saveCart={props.saveCart} value={value} setValue={setValue} />
              </div>
              <div className='mobie-items'>
                <CouponCode view={'mobile'} />
                <SpecialInstructions handleSpecialInstruction={props.handleSpecialInstruction} handleAternateNumber={props.handleAlternateNumber} />
                <BucketCartItems />
              </div>
            </div>
            <div className="col-lg-4 cart-data">
              <CouponCode view={'desktop'} />
              <GusetCheckOut validateStoreSpecification={validateStoreSpecification} clickNext={clickNext} />
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showHide}
        center
        onHide={handleClose}
      >
        <div className='modal-design'>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Modal.Header className='border-0 p-0' closeButton>
          <Modal.Title className='font-bold h4 text-center w-75 m-auto'> {t("ITEMS_NOT_AVAILABLE_MESSAGE")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='w-100 delivery-order'>
          <div className='row'>
            {removeableLsmItemsArr &&
              removeableLsmItemsArr.map((item: any, itemIndex: any) => {
                return <div key={itemIndex} className="col-lg-6 col-md-6 col-12">
                  <div className="menu-card" style={{ height: 250 }} >
                    <div className="menue-card" >
                      <img className='menu-img w-100' src={`${IMAGE_URL}${item.selectedsize ? item.selectedsize.image_url : item.combo.image_url}`} alt={item.selectedsize ? item.selectedsize.alt_text : item.combo.alt_text} />
                    </div>
                    <h3 style={{ fontSize: "16px", marginTop: "2px" }}> {item.item &&
                      item.item.item_name}
                      {item.combo &&
                        item.combo.combo_name}</h3>
                  </div>
                </div>
              })}
          </div>
          <div className='d-flex justify-content-center w-100 mb-3'>
            <Button variant="contained" color="error" className="text-center bg-theme" onClick={removeLsmItems}>
              {t("CONFIRM")}
            </Button>
          </div>
        </Modal.Body>

      </Modal>
    </div>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    handleSpecialInstruction: (event: any) => {
      dispatch(handleSpecialInstruction(event));
    },
    handleAlternateNumber: (event: any) => {
      dispatch(handleAlternateNumber(event));
    },
    saveCart: function (cart: any[]) {
      dispatch(saveCart(cart));
    },
    getCrossSellItems: (data: any) => {
      dispatch(getCrossSellItems(data))
    },
    getCart: function (cart: any[]) {
      dispatch(getCart());
    },
  };
};

export default connect(null, mapDispatchToProps)(Bucket);

